<template>
  <span class="animated-decimal-number">
    <animated-number :value="integerPart"></animated-number><span class="decimal">.<animated-number :value="decimalPart"></animated-number></span>
  </span>
</template>

<script>
import AnimatedNumber from './AnimatedNumber.vue';
import money from '../utils/money';

export default {
  name: 'AnimatedDecimalNumber',
  components: {
    AnimatedNumber,
  },
  props: {
    value: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      internalValue: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.internalValue = newValue;
    },
  },
  computed: {
    decimalPart() {
      return this.internalValue && money.extractRoundedDecimalPart(this.internalValue, 1);
    },
    integerPart() {
      return this.internalValue && money.extractRoundedIntegerPart(this.internalValue, 1);
    },
  },
};
</script>

<style scoped>

</style>
